export const discountTemplatesKeys = {
  all: ['discount-templates'] as const,
  lists: () => [...discountTemplatesKeys.all, 'list'] as const,
  list: () => [...discountTemplatesKeys.lists()] as const,
};
